import { FluidImage, SelectionSetTileImageContainer, SkeletonText } from '@vp/swan'
import type { OrderLineItem } from '@shared/types/order.types'
import { useProductImage } from '@shared/hooks/use-product-image'

interface ProductImageProps {
  item: OrderLineItem
}

export const ProductImage = ({ item }: ProductImageProps) => {
  const { src, srcSet, isLoading } = useProductImage(item)

  if (isLoading) {
    return (
      <SelectionSetTileImageContainer>
        <SkeletonText fontSize="40px" />
      </SelectionSetTileImageContainer>
    )
  }

  if (!src) return null

  return (
    <SelectionSetTileImageContainer>
      <FluidImage src={src} srcSet={srcSet} alt={item.productName} />
    </SelectionSetTileImageContainer>
  )
}
